import { useEffect, useState } from "react";

type AssetManifest = Record<string, string>;

let manifestRequest: Promise<AssetManifest> | undefined;

function loadManifest(): Promise<AssetManifest> {
  manifestRequest ??= fetch("/assets/nl/manifest.json", { cache: "no-cache" })
    .then((response) => response.ok ? response.json() as Promise<unknown> : {})
    .then((value) => {
      if (!value || typeof value !== "object" || Array.isArray(value)) return {};
      return Object.fromEntries(Object.entries(value).filter((entry): entry is [string, string] => (
        typeof entry[1] === "string"
        && !entry[1].startsWith("/")
        && !entry[1].includes("..")
        && !entry[1].includes(":")
      )));
    })
    .catch(() => ({}));
  return manifestRequest;
}

export function OfficialArtwork({ assetKey, className }: { assetKey: string; className?: string }) {
  const [source, setSource] = useState<string>();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let mounted = true;
    void loadManifest().then((manifest) => {
      if (mounted && manifest[assetKey]) setSource(`/assets/nl/${manifest[assetKey]}`);
    });
    return () => { mounted = false; };
  }, [assetKey]);

  if (!source || failed) return null;
  return <img className={className} src={source} alt="" aria-hidden="true" draggable={false} onError={() => setFailed(true)} />;
}
